import { APIModel } from "app/state/api";
import { ApiCallModel } from "app/state/api/interfaces";

export const ExplorerSectors: ApiCallModel = {
  ...APIModel(
    `${process.env.REACT_APP_API}/explorer/general/sectors/{transactionTypeCode}/{year}`
  ),
};

export const ExplorerSectorOfTheMonth: ApiCallModel = {
  ...APIModel(`${process.env.REACT_APP_API}/explorer/sector-of-the-month`),
};

export const ExplorerSectorStats: ApiCallModel = {
  ...APIModel(
    `${process.env.REACT_APP_API}/explorer/sector/stats/{code}/{transactionTypeCode}`
  ),
};

export const ExplorerSectorPartners: ApiCallModel = {
  ...APIModel(
    `${process.env.REACT_APP_API}/explorer/general/organisations-network/{transactionTypeCode}`
  ),
};

export const ExplorerSectorsList: ApiCallModel = {
  ...APIModel(
    `${process.env.REACT_APP_API}/explorer/sector/list/{transactionTypeCode}`
  ),
};

export const ExplorerHomeSectors: ApiCallModel = {
  ...APIModel(
    `${process.env.REACT_APP_API}/explorer/general/sectors/{transactionTypeCode}/{year}`
  ),
};

// Sector Page

export const ExplorerSectorPageOverviewStats: ApiCallModel = {
  ...APIModel(
    `${process.env.REACT_APP_API}/explorer/sector/detail/{code}/{transactionTypeCode}`
  ),
};

export const ExplorerSectorPageLocations: ApiCallModel = {
  ...APIModel(
    `${process.env.REACT_APP_API}/explorer/general/locations-stats/{transactionTypeCode}`
  ),
};

export const ExplorerSectorPageLocationsMap: ApiCallModel = {
  ...APIModel(
    `${process.env.REACT_APP_API}/explorer/general/locations-map/{transactionTypeCode}`
  ),
};

export const ExplorerSectorPageSDGs: ApiCallModel = {
  ...APIModel(
    `${process.env.REACT_APP_API}/explorer/general/sdgs/{transactionTypeCode}`
  ),
};

export const ExplorerSectorOrganisationsNetwork: ApiCallModel = {
  ...APIModel(
    `${process.env.REACT_APP_API}/explorer/general/organisations-network/{transactionTypeCode}`
  ),
};

export const ExplorerSectorOrganisationsDonut: ApiCallModel = {
  ...APIModel(
    `${process.env.REACT_APP_API}/explorer/general/organisations-donut/{transactionTypeCode}`
  ),
};

export const ExplorerSectorPageActivityTable: ApiCallModel = {
  ...APIModel(
    `${process.env.REACT_APP_API}/explorer/activity/list/{transactionTypeCode}/{page}`
  ),
};

export const ExplorerSectorPageSectorFunding: ApiCallModel = {
  ...APIModel(
    `${process.env.REACT_APP_API}/explorer/general/sectors/{transactionTypeCode}/{year}`
  ),
};

export const ExplorerSectorPageSectorOverTheYears: ApiCallModel = {
  ...APIModel(
    `${process.env.REACT_APP_API}/explorer/sector/{code}/{transactionTypeCode}/over-the-years`
  ),
};
